module.exports = __webpack_public_path__ + "img/main_logo.12b62a95.svg";